export const base64ToBlob = async (
  base64: string,
  mimeType: string
): Promise<Blob> => {
  const response = await fetch(
    base64.startsWith('data:')
      ? base64
      : `data:${mimeType};base64,${base64}`
  )

  return response.blob()
}
